/*
 * Sorgente unica delle recensioni.
 *
 * Ordine di priorità:
 *   1. CSV incollato nel theme editor        (window.UPSIL_REVIEWS.csv)
 *   2. CSV caricato in Contenuti -> File     (window.UPSIL_REVIEWS.url)
 *   3. JSON per prodotto generato da scripts/build-reviews.mjs
 *
 * Il CSV accetta separatore virgola, punto e virgola o tab (Excel italiano usa ";")
 * e intestazioni in italiano o in inglese.
 */
(function () {
  'use strict';

  var ALIAS = {
    product_handle: ['product_handle', 'handle', 'prodotto', 'product'],
    rating:         ['rating', 'voto', 'stelle', 'stars'],
    author:         ['author', 'autore', 'nome', 'name'],
    city:           ['city', 'citta', 'città', 'luogo'],
    date:           ['date', 'data'],
    title:          ['title', 'titolo'],
    body:           ['body', 'testo', 'recensione', 'review', 'commento'],
    verified:       ['verified', 'verificata', 'verificato', 'acquisto_verificato'],
    source:         ['source', 'fonte']
  };

  function norm(s) {
    return String(s || '').trim().toLowerCase()
      .replace(/^﻿/, '')
      .replace(/\s+/g, '_');
  }

  /* separatore: si guarda la prima riga, ignorando quello che sta fra virgolette */
  function sniff(text) {
    var line = '', quoted = false;
    for (var i = 0; i < text.length; i++) {
      var c = text[i];
      if (c === '"') quoted = !quoted;
      else if (c === '\n' && !quoted) break;
      line += c;
    }
    var best = ',', top = 0;
    [',', ';', '\t'].forEach(function (d) {
      var n = line.split(d).length - 1;
      if (n > top) { top = n; best = d; }
    });
    return best;
  }

  function parseCsv(text, delim) {
    var src = String(text).replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    var rows = [], row = [], field = '', quoted = false;

    for (var i = 0; i < src.length; i++) {
      var c = src[i];
      if (quoted) {
        if (c === '"') {
          if (src[i + 1] === '"') { field += '"'; i++; }
          else quoted = false;
        } else field += c;
      } else if (c === '"') quoted = true;
      else if (c === delim) { row.push(field); field = ''; }
      else if (c === '\n') { row.push(field); rows.push(row); row = []; field = ''; }
      else field += c;
    }
    if (field !== '' || row.length) { row.push(field); rows.push(row); }
    return rows.filter(function (r) { return r.some(function (v) { return String(v).trim() !== ''; }); });
  }

  /* "01/09/2026" e "2026-09-01" vanno bene entrambi */
  function parseDate(v) {
    if (!v) return null;
    var it = /^(\d{1,2})[\/.-](\d{1,2})[\/.-](\d{4})$/.exec(v);
    if (it) return new Date(+it[3], +it[2] - 1, +it[1]);
    var d = new Date(v);
    return isNaN(d) ? null : d;
  }

  function isTrue(v) {
    return /^(1|true|si|sì|yes|y|vero|x)$/i.test(String(v).trim());
  }

  function rowsToReviews(rows) {
    if (!rows.length) return [];
    var head = rows[0].map(norm);
    var idx = {};
    Object.keys(ALIAS).forEach(function (key) {
      idx[key] = -1;
      ALIAS[key].some(function (a) {
        var p = head.indexOf(norm(a));
        if (p > -1) { idx[key] = p; return true; }
        return false;
      });
    });
    if (idx.product_handle < 0 || idx.body < 0) return [];

    var out = [];
    rows.slice(1).forEach(function (r) {
      function at(k) { return idx[k] > -1 ? String(r[idx[k]] || '').trim() : ''; }
      var handle = at('product_handle').toLowerCase();
      var body = at('body');
      var rating = Math.round(Number(String(at('rating')).replace(',', '.')));
      if (!handle || !body) return;
      if (!(rating >= 1 && rating <= 5)) rating = 5;
      var d = parseDate(at('date'));
      out.push({
        handle: handle,
        rating: rating,
        author: at('author') || 'Cliente',
        city: at('city'),
        date: d ? d.toISOString().slice(0, 10) : '',
        ts: d ? d.getTime() : 0,
        title: at('title'),
        body: body,
        verified: idx.verified > -1 ? isTrue(at('verified')) : false,
        source: at('source')
      });
    });
    return out;
  }

  function fromCsv(text) {
    if (!text || !String(text).trim()) return [];
    return rowsToReviews(parseCsv(text, sniff(text)));
  }

  var pending = null;

  /* tutte le recensioni del negozio, caricate una volta sola per pagina */
  function loadAll() {
    if (pending) return pending;
    var cfg = window.UPSIL_REVIEWS || {};

    var inline = fromCsv(cfg.csv);
    if (inline.length) {
      pending = Promise.resolve(inline);
      return pending;
    }

    if (cfg.url) {
      pending = fetch(cfg.url, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('csv ' + r.status); return r.text(); })
        .then(fromCsv)
        .catch(function () { return []; });
      return pending;
    }

    pending = Promise.resolve([]);
    return pending;
  }

  /* recensioni di un prodotto: prima il CSV, poi il JSON generato dallo script */
  function forHandle(handle, jsonUrl) {
    handle = String(handle || '').toLowerCase();
    return loadAll().then(function (all) {
      var mine = all.filter(function (r) { return r.handle === handle; });
      if (mine.length || !jsonUrl) return mine;
      return fetch(jsonUrl)
        .then(function (r) { if (!r.ok) throw new Error('json ' + r.status); return r.json(); })
        .then(function (j) { return (j && j.reviews) || []; })
        .catch(function () { return []; });
    });
  }

  function summarize(list) {
    var breakdown = [0, 0, 0, 0, 0];   /* 5,4,3,2,1 stelle */
    var sum = 0;
    list.forEach(function (r) {
      var n = Math.min(5, Math.max(1, Math.round(r.rating)));
      breakdown[5 - n] += 1;
      sum += n;
    });
    return {
      reviews: list,
      count: list.length,
      average: list.length ? Math.round(sum / list.length * 10) / 10 : 0,
      breakdown: breakdown
    };
  }

  function byNewest(a, b) { return (b.ts || 0) - (a.ts || 0); }

  function stars(n) {
    n = Math.min(5, Math.max(0, Math.round(n)));
    return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
  }

  window.UpsilReviews = {
    loadAll: loadAll,
    forHandle: forHandle,
    summarize: summarize,
    byNewest: byNewest,
    stars: stars,
    parseCsv: fromCsv
  };
})();
